import { createApi } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { GraphQLClient, ClientError } from 'graphql-request';
import { getAuthToken } from 'lib/utils/auth';
import { isHttpSecure } from "lib/utils/utils";
import { gatewayServiceBaseUrl } from "lib/consts/arcGateway";
import type { RootState } from 'store';

export const getClient = (arcHost?: string | null, arcId?: string | null): GraphQLClient => {
    const host = arcHost || process.env.REACT_APP_SINGLE_ARC_HOSTNAME || window.location.hostname;
    const scheme = isHttpSecure() ? "https" : "http";
    const gateway = gatewayServiceBaseUrl("missionStorage", arcId, arcHost);
    if (arcId && !gateway) {
        throw new Error("Fleet proxy host is unavailable");
    }
    const u = new URL(gateway ? `${gateway}/graphql` : `${scheme}://${host}:8000/graphql`);
    const token = getAuthToken();
    return new GraphQLClient(u.toString(), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

const missionStorageBaseQuery: BaseQueryFn<
    { document: string; variables?: Record<string, unknown> },
    unknown,
    unknown
> = async ({ document, variables }, api) => {
    const { arcId, arcProxyHost } = (api.getState() as RootState).arcProxy;
    try {
        const data = await getClient(arcProxyHost, arcId).request(document, variables);
        return { data };
    } catch (error) {
        if (error instanceof ClientError) {
            return { error: { status: error.response.status, error: error.message, data: error.response.errors } };
        }
        return { error: { status: 'FETCH_ERROR', error: String(error) } };
    }
};

export const api = createApi({
    reducerPath: 'missionStorageApi',
    baseQuery: missionStorageBaseQuery,
    tagTypes: ['Mission', 'Action', 'Resource'],
    endpoints: () => ({}),
});
